import {useGetters} from "vuex-composition-helpers";
import store from "@/store";

export const {department} = useGetters(store, {
    department: '[MAIN] getDepartment',
});
